var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLearn = function SvgIconLearn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.904 14.485 5.163-8.303 5.162 8.303z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.949 12.5 6.11-10.506L14.17 12.5z"
  }))));
};
export { SvgIconLearn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGc+CjxwYXRoIGQ9Ik0yLjkwNDEyIDE0LjQ4NTRMOC4wNjY2NSA2LjE4MjI5TDEzLjIyOTIgMTQuNDg1NEgyLjkwNDEyWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTEuOTQ4OTcgMTIuNUw4LjA1OTI2IDEuOTk0NDlMMTQuMTY5NSAxMi41SDEuOTQ4OTdaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L2c+Cjwvc3ZnPgo=";